export default {
  plural: 'Email Шаблоны',
  single: 'Email Шаблон',
  description: 'Описание',
  search: 'Поиск',
  create: 'Создать email шаблон',
  subject: 'Тема',
  subjectUk: 'Тема (UK)',
  subjectEn: 'Тема (EN)',
  key: 'Ключ',
  remove: 'Удалить',
  edit: 'Изменить'
};
